import { useQuery } from "@tanstack/react-query";

import api from "../api/api";
import type { FindOrderByIdAndUserIdOutputDto } from "../types/codegen";

export const useOrder = (orderId?: string) => {
  return useQuery({
    queryKey: ["order", orderId] as const,
    queryFn: ({ signal }) =>
      api.get<FindOrderByIdAndUserIdOutputDto>(`/orders/${orderId}`, {
        signal,
      }),
    select: (response) => response.data.data,
    enabled: Boolean(orderId),
    refetchInterval: (query) => {
      const response = query.state.data;

      // we need to wait until all reservations are created
      if (
        response?.data?.data?.reservations.some(
          (reservation) => reservation.status === "IN_PROGRESS",
        )
      ) {
        return 2000;
      }

      return false;
    },
  });
};
